import React from 'react';
import {
  Box,
  Grid,
  Flex,
  Heading,
  Text,
  Spinner,
  Card,
  CardHeader,
  CardBody,
  Avatar,
  HStack,
  Divider,
  CircularProgress,
  CircularProgressLabel,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiClock } from 'react-icons/fi';
import { formatTime } from '../utils/formatters';

/**
 * EquipeStatus - Component for displaying team performance metrics
 * 
 * @param {Object} props - Component props
 * @param {Array} props.equipe - Array of team member objects
 * @param {boolean} props.isLoading - Loading state
 */
const EquipeStatus = ({ equipe, isLoading }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const lightBg = useColorModeValue('gray.50', 'gray.600');

  return (
    <Card bg={cardBg} boxShadow="md" mb={6}>
      <CardHeader pb={2}>
        <Heading size="md">Performance da Equipe</Heading>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Flex justify="center" py={6}>
            <Spinner />
          </Flex>
        ) : (
          <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }} gap={6}>
            {equipe.map((membro, index) => (
              <Card key={index} variant="outline" overflow="hidden">
                <CardHeader bg={lightBg} py={3} px={4}>
                  <Flex align="center">
                    <Avatar 
                      size="sm" 
                      name={membro.nome} 
                      mr={2}
                      bg={
                        index === 0 ? 'blue.500' :
                        index === 1 ? 'green.500' :
                        index === 2 ? 'purple.500' : 'yellow.500'
                      } 
                    />
                    <Text fontWeight="bold" fontSize="md">{membro.nome}</Text>
                  </Flex>
                </CardHeader>
                <CardBody py={3} px={4}>
                  <HStack mb={3} justify="center">
                    <CircularProgress 
                      value={membro.satisfacao} 
                      color={membro.satisfacao > 90 ? 'green.400' : 'yellow.400'} 
                      size="80px"
                      thickness="8px"
                    >
                      <CircularProgressLabel fontSize="sm">
                        {membro.satisfacao}%
                      </CircularProgressLabel>
                    </CircularProgress>
                    <Box>
                      <Text fontSize="sm" fontWeight="medium">Tickets Hoje: {membro.ticketsHoje}</Text>
                      <HStack fontSize="xs" color="gray.500" mt={1}>
                        <Text>Abertos: {membro.abertos}</Text>
                        <Text>•</Text>
                        <Text>Resolvidos: {membro.resolvidos}</Text>
                      </HStack>
                    </Box>
                  </HStack>
                  <Divider mb={3} />
                  <Flex justify="center" fontSize="sm">
                    <HStack>
                      <Icon as={FiClock} />
                      <Text>Tempo médio: {formatTime(membro.tempoMedio)}</Text>
                    </HStack>
                  </Flex>
                </CardBody>
              </Card>
            ))}
          </Grid>
        )}
      </CardBody>
    </Card>
  );
};

export default EquipeStatus;